import { DETAIL } from './common';

const PERSPECTIVES = 'perspectives';
const OOB = 'oob';

export const perspectiveQueryKeys = {
    all: [PERSPECTIVES],
    detail: (nodeId?: string) => [PERSPECTIVES, DETAIL, String(nodeId)],
    oob: (nodeId?: string) => [OOB, String(nodeId)]
};
